/**
*  Checks whether an object is a promise (or possible).
*  @param {any} obj — The object to check
 * @returns {boolean}
 */
export function isPromise(obj) {
  return (
    obj !== null
    && (typeof obj === 'object' || typeof obj === 'function')
    && typeof obj.then === 'function'
  )
}

/**
 * Race between the required workPromise and the abortPromise.
 * If abortPromise fires, it will immediately complete Promise.race
 * and, accordingly, Promise.all will complete as well.
 *
 * */
export const makeCancellable = (workPromise, abortController) => {
  if (!abortController) return workPromise

  let storedReject

  const abortHandler = () => {
    if (storedReject) {
      storedReject(new Error('Aborted toBlob() operation'))
    }
  }

  const abortPromise = new Promise((_, reject) => {
    storedReject = reject
    abortController.signal.addEventListener('abort', abortHandler)
  })

  return Promise.race([ workPromise, abortPromise ])
    .finally(() => {
      abortController.signal.removeEventListener('abort', abortHandler)
    })
}

// for await setTimeout/function with callback
export function promisify(originalFn) {
  // eslint-disable-next-line
  return function (...args) {
    return new Promise((resolve, reject) => {
      // eslint-disable-next-line
      originalFn(...args, (err, data) => {
        if (err) return reject(err)
        resolve(data)
      })
    })
  }
}
